<template>
  <div>
    <div v-if="online_fitting" style="padding-top: 30px;">
      <img
              v-if="$root.questions_to_include[$root.category].includes('shape')"
              class="shape_img"
              :src="shape_img"
              style="max-width: 100px; max-height: 100px;"
      >

      <p>
        <span
          v-if="$root.questions_to_include[$root.category].includes('band')"
          class="band_size"
        >Band: <b>{{ $root.underbust_size }}"</b></span>

        <span
          v-if="$root.questions_to_include[$root.category].includes('cup')"
          class="cup_size"
        >Cup: <b>{{ $root.cup_size }}"</b></span>

        <span
          v-if="$root.questions_to_include[$root.category].includes('shape')"
          class="shape"
        >Shape: <b>{{ $root.shapeToDisplayName($root.shape) }}</b></span>

        <span
          v-if="$root.questions_to_include[$root.category].includes('waist_hips')"
          class="shape"
        >Waist:
          <b>
            <template v-if="!$root.skipped_bottoms">
              {{ $root.waist_size }}"
            </template>
            <template v-else>
              Skipped
            </template>
          </b>
        </span>

        <span
          v-if="$root.questions_to_include[$root.category].includes('waist_hips')"
          class="shape"
        >Hip:
          <b>
            <template v-if="!$root.skipped_bottoms">
              {{ $root.hip_size }}"
            </template>
            <template v-else>
              Skipped
            </template>
          </b>
        </span>

        <span
          v-if="$root.questions_to_include[$root.category].includes('weight')"
          class="shape"
        >Weight: <b>{{ $root.weight }}"</b></span>
      </p>

      <!-- <h2>
        Bra size: <b>(US) {{ $root.us_from_uk(online_fitting.fitted_size) }} /
                  (UK) {{ online_fitting.fitted_size }}</b>
        <div style="display: inline-block; width: 10px;" />
        Bottom Size: <b>{{ online_fitting.generic_bottom_simple_size }}</b>
      </h2> -->

      <h2 class="text-center">What are {{ $root.is_mini_or_baby ? 'they' : 'you' }} looking for?</h2>
      <div class="container">
        <!-- eslint-disable -->
        <button
          v-if="$root.division_types[$root.category].includes(key)"
          v-for="(value, key) in $root.types"
          :key=key
          class="btn"
          :class="{selected: $root.type === value}"
          @click.prevent="$root.type = value;"
        >
          {{key}}
        </button>
        <!-- eslint-enable -->
      </div>

      <!-- FIT COMPONENT SLIDER -->
      <h2 class="text-center">What fit do {{ $root.is_mini_or_baby ? 'they' : 'you' }} prefer?</h2>
      <div
        v-if="online_fitting"
        class="fit"
      >
        <!-- RANGE VALUE SLIDER -->
        <div class="range-value">
          <!-- LOOSE -->
          <div class="flex">
            <button
              class="btn btn-wide btn-slide"
              :class="{selected: $root.fit === 'loose'}"
              @click.prevent="$root.fit = 'loose';"
            >
              <!-- <template v-if="$root.isBottomType">
                {{ $root.get_alternate_size(online_fitting.generic_bottom_simple_size, 1) }}
              </template>
              <template v-else>
                {{ $root.us_from_uk(online_fitting.loose_fit) }} US / {{ online_fitting.loose_fit }} UK
              </template> -->
              <span>LOOSE</span>
            </button>
          </div>

          <!-- NORMAL -->
          <div class="flex">
            <button
              class="btn btn-wide btn-slide"
              :class="{selected: $root.fit === 'normal'}"
              @click.prevent="$root.fit = 'normal';"
            >
              <!-- <template v-if="$root.isBottomType">
                {{ online_fitting.generic_bottom_simple_size }}
              </template>
              <template v-else>
                {{ $root.us_from_uk(online_fitting.fitted_size) }} US / {{ online_fitting.fitted_size }} UK
              </template> -->
              <span>SNUG</span>
            </button>
          </div>

          <!-- SNUG -->
          <div class="flex">
            <button
              class="btn btn-wide btn-slide"
              :class="{selected: $root.fit === 'tight'}"
              @click.prevent="$root.fit = 'tight';"
            >
              <!-- <template v-if="$root.isBottomType">
                {{ $root.get_alternate_size(online_fitting.generic_bottom_simple_size, -1) }}
              </template>
              <template v-else>
                {{ $root.us_from_uk(online_fitting.snug_fit) }} US / {{ online_fitting.snug_fit }} UK
              </template> -->
              <span>TIGHT</span>
            </button>
          </div>

          <!-- INDICATOR -->
          <template>
            <div v-if="usePercentage" class="left-indicator" :style="leftComputedStyle"></div>

            <div class="indicator" :style="computedStyle"></div>

            <div v-if="usePercentage" class="right-indicator" :style="rightComputedStyle"></div>
          </template>
        </div>
      </div>
    </div>
    <div v-else>
      Loading...
    </div>
  </div>
</template>

<script>
  import shapes from '../data/shapes';

  export default {
    props: {
      online_fitting: {
        type: Object,
        default: null,
      }
    },
    computed: {
      usePercentage() {
        return (
          (this.$root.category === 'youth_lady' && this.$root.type === 'Tops')
          || (this.$root.category === 'men')
          || (this.$root.category === 'women' && !['Full Coverage', '1-Piece', 'Rash Guards'].includes(this.$root.type))
        );
      },
      shape_img(){
        let shape = shapes.find(
          shape => shape.value === this.$root.shape
        );
        if(shape){
          return shape.img;
        }
      },
      computedStyle() {
        if (this.usePercentage) {
          if (this.$root.isBottomType) {
            const range = 66.5 - 33.5;
            let val = 33.5 + (range - (range * this.online_fitting.bottoms_percentage))

            return { left: val + '%' };
          } else {
            const range = 66.5 - 33.5;
            let val = 33.5 + (range - (range * this.online_fitting.bra_percentage));

            return { left: val + '%' };
          }
        } else {
          const range = 66.5 - 33.5;
          let val = 33.5 + (range - (range * .5))

          return { left: val + '%' };
        }
      },
      leftComputedStyle() {
        if (this.$root.isBottomType) {
          const range = 66.5 - 33.5;
          let val = 33.5 + (range - (range * this.online_fitting.bottoms_percentage))
          val -= 16.5;

          return { left: val + '%' };
        } else {
          const range = 66.5 - 33.5;
          let val = 33.5 + (range - (range * this.online_fitting.band_percentage));

          return { left: val + '%' };
        }
      },
      rightComputedStyle() {
        if (this.$root.isBottomType) {
          const range = 66.5 - 33.5;
          let val = 33.5 + (range - (range * this.online_fitting.bottoms_percentage))
          val += 16.5;

          return { left: val + '%' };
        } else {
          const range = 66.5 - 33.5;
          let val = 33.5 + (range - (range * this.online_fitting.cup_percentage));

          return { left: val + '%' };
        }
      },
      secondRangeValue() {
        if (!this.online_fitting.bottoms_percentage) {
          return { left: 50 + '%' };
        }
      },
    },
  }
</script>

<style lang="less" scoped>
.kortni-jeane-fitting {
  button {
    display: inline-block !important;
    padding: 10px !important;
    width: 150px !important;
    margin-left: 15px !important;
    margin-right: 15px !important;
    margin-bottom: 15px !important;

    &.btn-wide {
      width: 200px !important;
    }
  }

  .shape_img {
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .band_size, .cup_size, .shape {
    margin-left: 15px;
    margin-right: 15px;
  }

  @yellow: darkgrey;
  @pink: lightgrey;
  @blue: rgb(24, 31, 51);
  @red: #FF0000;

  h3 {
    margin: 24px 0 6px 0;
  }

  .container {
    max-width: 800px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    
    button {
      width: 210px;
      padding: 6px 0;
      margin: 6px;
      background-color: white;
      color: black;
      border: 2px solid black;
      outline: none;

      &.selected {
        border: 2px solid transparent;
        background-color: black;
        color: white;
      }
    }
  }

  .fit .range-value .btn {
    margin: 0px;
    outline: 0;
  }
  .fit .range-value .btn-slide {
      background-color: transparent !important;
      border: 0px !important;
      color: darkgrey !important;
      border-bottom: 9px solid @yellow !important;
      width: 100% !important;
      margin-bottom: 8px !important;
      border-radius: 0px !important;
      position: relative !important;
      font-size: 16px !important;
      margin-left: 0 !important;
      margin-right: 0 !important;
  }
  .fit .range-value {
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      max-width: 1024px;
      margin: 0 auto;
      margin-bottom: 40px;
  }
  .fit .range-value .flex {
      flex: 1;
  }
  .fit .fit-label {
      padding: 0px 10px;
  }
  .fit .range-value .flex:nth-child(3n+2) .btn-slide {
      border-color: @blue !important;
  }
  .fit .range-value .flex:nth-child(3n+1) .btn-slide {
      border-color: @pink !important;
  }
  .fit .range-value .btn-slide.selected {
      color: black !important;
      font-weight: 700 !important;
  }
  .range-value {
    position: relative;
  }
  .fit .range-value .indicator {
    content: '';
    position: absolute;
    top: calc(100% + 3px);
    transform: translateX(-50%);
    width: 0px;
    height: 0px;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 15px solid rgb(24, 31, 51);
  }
  .indicator::after {
    content: 'Your Fit Range';
    position: absolute;
    font-size: .8em;
    width: 150px;
    top: 20px;
    left: -73px;
    color: rgb(24, 31, 51);
    font-weight: 700;
    text-transform: uppercase;
  }
  .left-indicator {
    content: '';
    position: absolute;
    top: calc(100% - 37px);
    transform: translateX(-50%);
    width: 0px;
    height: 50px;
    border-left: 3px solid rgb(24, 31, 51);
  }
  .right-indicator {
    content: '';
    position: absolute;
    top: calc(100% - 37px);
    transform: translateX(-50%);
    width: 0px;
    height: 50px;
    border-left: 3px solid rgb(24, 31, 51);
  }
}
</style>
